import Immutable from 'immutable';
import queryString from 'query-string';
import URL from 'url-parse';
import urlTemplate from 'url-template';
export function foldImmutableQueryValue(iqv) {
  return function (string, set) {
    if (typeof iqv === 'string') {
      return string(iqv);
    } else if (Immutable.Set.isSet(iqv)) {
      return set(iqv);
    } else {
      throw new TypeError("foldResolvedImmutableQueryValue is not comprehensive in ResolvedImmutableQueryValue: ".concat(JSON.stringify(iqv)));
    }
  };
}
export function resolveImmutableQuery(search) {
  const immutableMap = Immutable.fromJS(queryString.parse(search), (key, value) => Immutable.Collection.isIndexed(value) ? value.toSet() : value.toMap()); // $FlowFixMe Immutable.fromJS is ambiguous about what it returns, but this will always be a map

  return immutableMap;
}
export function resolveSearchFromImmutableQuery(query) {
  const stringifiedQuery = stringifyImmutableQuery(query);
  return stringifiedQuery ? "?".concat(stringifiedQuery) : '';
}

const filterEmptyStringsFromQuery = queryObject => {
  return Object.entries(queryObject).filter(([_, v]) => !(typeof v === 'string' && v.trim() === '')).reduce((res, [k, _]) => {
    res[k] = queryObject[k];
    return res;
  }, {});
};

function stringifyImmutableQuery(query) {
  const queryObject = query && query.toJS();
  return queryObject ? queryString.stringify(filterEmptyStringsFromQuery(queryObject)) : '';
}

export function resolveUrlFromTemplateAndParameters(options) {
  return urlTemplate.parse(options.template).expand(options.parameters);
}
export function transformUriTemplateToRoutePath({
  template
}) {
  return template.replace(/{([^{}]+)}/g, (_, expression) => ":".concat(expression));
}
export function transformRoutePathToUriTemplate({
  routePath
}) {
  return routePath.replace(/:([^/]+)/g, (_, expression) => "{".concat(expression, "}"));
}
export function validateSafeAbsoluteUrl(url) {
  if (!url) return null;
  const urlObj = new URL(url, {});
  const scheme = urlObj.protocol.toLowerCase();

  switch (scheme) {
    case 'http:':
    case 'https:':
      return url;

    default:
      return null;
  }
}
/**
 * Replaces the value of a query parameter in a url if present,
 * and adds it if not, and returns the path only.
 *  @example
 * updateQueryParam(https://google.com/something?a=1, a, 3); // returns /something?a=3
 */

export const updateQueryParam = (url, paramName, paramValue) => {
  const newUrl = new URL(url, {}, true);
  const {
    query,
    pathname,
    hash
  } = newUrl;
  const urlPath = new URL('', {});
  urlPath.set('query', { ...query,
    [paramName]: paramValue
  }).set('pathname', pathname).set('hash', hash);
  return urlPath.toString();
};
/**
 * Removes a query parameter and its value from a given url
 * and and returns the path only.
 *  @example
 * unsetQueryParam(https://google.com/something?a=1, a); // returns /something
 */

export const unsetQueryParam = (url, paramName) => {
  const newUrl = new URL(url, {}, true);
  const {
    query,
    pathname,
    hash
  } = newUrl;
  const {
    [paramName]: _paramToRemove,
    ...otherQueryParams
  } = query;
  const urlPath = new URL('', {});
  urlPath.set('query', { ...otherQueryParams
  }).set('pathname', pathname).set('hash', hash);
  return urlPath.toString();
};
export const getLocationPath = () => window.location.hash.split('#')[1].split('?')[0];